export class Back {}

export const TO = {
  back: Back,
};
